import React from "react";
import axios from "axios";

import { store } from "../../redux/store";


import { connect } from "react-redux";
import { Bar } from "react-chartjs-2";
import './Graph.css';
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();

class BillPaymentGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNo: this.props.phone,
      durationList: [
        { value: "Select", label: "Select" },
        { value: "3", label: "3 months" },
        { value: "6", label: "6 months" },
        { value: "12", label: "1 year" }
      ],
      durationSelected: '3',
      graphRes: '',
      graphMapLength: ''
    }
  }

  componentDidMount() {
    this.loadGraph('3');
  }
  componentWillUnmount() {
  }
  test(val) {
    if (val / 3 == 2) {
      return true
    } else {
      return false
    }
  }

  durationSelect = (event) => {
    if (event.target.value == 'Select') {
      alert('Please select a duration');

    } else {
      this.setState({
        durationSelected: event.target.value
      })
      this.loadGraph(event.target.value);
    }
  }

  loadGraph(durationSelected) {


    var graphMonthList = [];
    var defaultMonthList = [];
    var successAmountList = [];
    var failureAmountList = [];
    var pendingAmountList = [];

    var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

    var today = new Date();
    var d;
    var month;

    for (var i1 = durationSelected - 1; i1 >= 0; i1 -= 1) {
      d = new Date(today.getFullYear(), today.getMonth() - i1, 1);
      var y = d.getFullYear().toString();
      month = monthNames[d.getMonth()];
      var values = month + " " + y;
      defaultMonthList.push(values);
    }

    console.log('defaultMonthList:'+defaultMonthList)

    var graphRes = {
      mapKeyList: defaultMonthList,
      successAmountList: successAmountList,
      failureAmountList: failureAmountList,
      pendingAmountList: pendingAmountList
    }

    this.setState({
      graphRes: graphRes
    })

    this.setState({
      graphMapLength: defaultMonthList.length
    })


    const headers = {
      'Authorization': 'Bearer ' + this.props.token,
      'client-id': this.props.agentInfo,
      'role': this.props.clientRole,
    }

    var graphUrl = '/api/v1/billpay/corp/consumer/billpay-graph/' + this.props.agentInfo + '/' +
      durationSelected;

    httpClient.get(graphUrl,
      { headers }
    ).then((response) => {
      console.log('graph response' + JSON.stringify(response.data));
      const map = new Map(Object.entries(response.data.data));
      // const map = new Map(Object.entries({}));
      var itr = map.keys();

      for (var i = 0; i < map.size; i++) {
        graphMonthList.push(itr.next().value);

      }


      var newArray = [];

      for (var i = 0; i < defaultMonthList.length; i++) {
        if (!graphMonthList.includes(defaultMonthList[i])) {
          newArray.push(defaultMonthList[i]);
        }
      }


      if (newArray.length > 0) {
        for (var k = 0; k < newArray.length; k++) {

          var successAmount = 0;
          successAmountList.push(successAmount);

          var failedAmount = 0;
          failureAmountList.push(failedAmount);

          var pendingAmount = 0;
          pendingAmountList.push(pendingAmount);
        }
      }



      if (graphMonthList.length > 0) {
        
        for (var i = 0; i < graphMonthList.length; i++) {
          var index = defaultMonthList.indexOf(graphMonthList[i]);
          console.log('month...'+graphMonthList[i])
          console.log('index:'+index)
          var successAmount = map.get(graphMonthList[i]).BILL_PAY_SUCCESS;
          console.log('successAmount:'+successAmount)
          successAmountList[index] = successAmount;
          var failedAmount = map.get(graphMonthList[i]).BILL_PAY_FAILED;
          console.log('failedAmount:'+failedAmount)
          failureAmountList[index] = failedAmount;
          var pendingAmount = map.get(graphMonthList[i]).BILL_PAY_PENDING;
          console.log('pendingAmount:'+pendingAmount)
          pendingAmountList[index] = pendingAmount;
        }
        
      }

  
      var graphRes = {
        mapKeyList: defaultMonthList,
        successAmountList: successAmountList,
        failureAmountList: failureAmountList,
        pendingAmountList: pendingAmountList
      }



      this.setState({
        graphRes: graphRes
      })

      this.setState({
        graphMapLength: defaultMonthList.length
      })

      //store.dispatch(setGraphResponse(response.data));

    }).catch(error => {
      var data = null;
      var response = {
        data: data
      }
      //store.dispatch(setGraphResponse('error'));

      console.log('graph service error...' + error);
      if (error.message.includes("401")) {
        tokenErrorHandler.tokenErrorHandle(error.message, '')
      } else {

      }

    });
  }

  render() {

    return (
      <div class="card">
        <div class="dashhead">
          <h3>Bill Payment</h3>
          <select class="form-select" id="monthId" aria-label=""
            onChange={this.durationSelect}>

            {this.state.durationList.map(duration => (
              <option value={duration.value}
              >{duration.label}</option>
            ))}

          </select>
        </div>
        {this.state.graphRes != '' &&

          <div class="grapreport">
            <p>Showing Graph For: Last {this.state.durationSelected} months</p>
            <Bar
              // id="mytxn" width="400" height="183"
              data={
                {
                  labels: this.state.graphRes.mapKeyList,
                  datasets: [
                    {
                      label: 'Success',
                      data: this.state.graphRes.successAmountList,
                      backgroundColor: '#009adb',
                      borderColor: '#ffffff',
                    },
                    {
                      label: 'Failed',
                      data: this.state.graphRes.failureAmountList,
                      backgroundColor: '#f95023',
                      borderColor: '#ffffff',
                    },
                    {
                      label: 'Pending',
                      data: this.state.graphRes.pendingAmountList,
                      backgroundColor: '#009adb',
                    }
                  ]
                }
              }
              options={
                {
                  plugins: {
                    legend: { display: false },
                  },
                  scales: {
                    x: {
                      stacked: true,
                    },
                    y: {
                      stacked: true,
                      ticks: { display: false },
                    },
                  }
                }
              }
            />
            {/* <canvas id="mytxn" width="400" height="183"></canvas> */}
          </div>
        }
      </div>

    );
  }
}

const mapStateToProps = (
  { errorMessageReduce: { errorMessage },
    miscReduce: { phone, agentInfo, token, clientRole } }
) => ({
  errorMessage, phone, agentInfo, token, clientRole
});

export default connect(mapStateToProps, null)(BillPaymentGraph);
